import { createAction } from 'redux-actions';

export const GET_CONTENT_COLLECTION = createAction('GET_CONTENT_COLLECTION');
export const GET_CONTENT_COLLECTION_START = createAction('GET_CONTENT_COLLECTION_START');
export const GET_CONTENT_COLLECTION_SUCCESS = createAction('GET_CONTENT_COLLECTION_SUCCESS');
export const GET_CONTENT_COLLECTION_ERROR = createAction('GET_CONTENT_COLLECTION_ERROR');
export const GET_CONTENT_COLLECTION_FINALLY = createAction('GET_CONTENT_COLLECTION_FINALLY');